import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

import { Loader } from '@c';
import { useActions } from '@h';
import { authActions } from '@r/auth/authSlice';

import { TestPreview } from '../Test/TestPreview';

import styles from './style.module.scss';

const useQuery = () => new URLSearchParams(useLocation().search);

const Playback = () => {
    const query = useQuery();
    const courseId = query.get('courseId');
    const initialType = query.get('type') || null;

    const { data: authData } = useSelector(({ auth }) => auth);
    const { loginCheck } = useActions(authActions);

    const [type, setType] = useState(initialType);

    useEffect(() => {
        loginCheck();
    }, [loginCheck]);

    if (authData === undefined) {
        return (
            <div className={styles.wrapper}>
                <Loader color="#007aff" />
            </div>
        );
    }

    if (authData === null) {
        return <Redirect to="/teacher" />;
    }

    return (
        <div className={styles.wrapper}>
            <TestPreview
                schemeId={courseId}
                type={type}
                onTypeChange={setType}
            />
        </div>
    );
};

export { Playback };
